import { Fragment, useContext } from 'react'
import { Card, Visible, Hidden } from '@leroy-merlin-br/backyard-react-ui'

import { ProductThumb } from 'reactGarden/ProductThumb'
import AssistedSaleProductList from 'reactGarden/AssistedSaleProductList'
import Pagination from 'reactGarden/Pagination'

import { ContextVisibility } from 'reactShared/components/ContextVisibility'

import { WishlistContext } from 'reactSite/Wishlist/context'

import * as S from './styled'
import { ProductShell } from '../Shell'
import { EntryKeyContext } from '../../context/EntryKeyContext'
import { onProductClickDataLayer } from '../../utils/data-layer'

const Products = () => {
  const {
    isLoadingProducts,
    metadata,
    products,
    setPage,
    profile: { region },
    type,
    query: { term },
    metaTags,
    baseUrl,
    isSearch
  } = useContext(EntryKeyContext)

  const { isOnWishlist } = useContext(WishlistContext)

  const renderProducts = () => (
    <S.Card>
      <S.Products>
        {products.map((product, index) => (
          <ProductThumb
            onClick={() =>
              onProductClickDataLayer({
                product,
                region,
                gaTrack: metaTags?.gaTrack,
                type,
                term: isSearch && term ? term.value : baseUrl,
                index,
                page: metadata.page,
                inWishlist: isOnWishlist(product.id)
              })
            }
            variableWidth
            product={product}
            key={product.id}
          />
        ))}
      </S.Products>
    </S.Card>
  )

  if (isLoadingProducts) {
    return <ProductShell />
  }

  return (
    <Fragment>
      <ContextVisibility when={['ecommerce', 'app']}>
        {renderProducts()}
      </ContextVisibility>

      <ContextVisibility when={['assisted-sale']}>
        <Visible untilKilo kilo>
          <AssistedSaleProductList products={products} />
        </Visible>

        <Hidden untilKilo kilo>
          {renderProducts()}
        </Hidden>
      </ContextVisibility>

      {metadata.pageCount > 1 && (
        <S.PaginationWrapper>
          <Pagination {...metadata} setPage={setPage} />
        </S.PaginationWrapper>
      )}
    </Fragment>
  )
}

export default Products
